// 组队相关
export default {
  SENT_SMSCODE: '/api/partner/login/sendSmsCode',                       // 获取验证码
  PERSON_REALNAME: '/api/partner/personRealname',                      // 个人实名
  ENTER_REALNAME: '/api/partner/enterpriseRealname',                  // 企业实名
  BANK_INFOLIST: '/api/partner/bankInfoList',                        // 银行列表
  AUTH_REALNAME: '/api/partner/authPersonRealname',                 // 个人实名短信确认
  GET_TRANSFER_AMOUNT: '/api/partner/transferRandomAmount',        // e签包打款到第三方
  VERIFY_AMOUNT: '/api/partner/verifyRandomAmount',               // 确认随机金额
  VALIDATE_SMSCODE_PT: '/api/partner/validatePhoneCode',         // 验证验证码
  AGREEMENT_LIST: '/api/partner/agreementList',                 // 合约列表
  BETCH_SIGN: '/api/agreement/batchSignAgreements',            // 签署确认
  SEND_SIGNSMS: '/api/partner/sendSignSms'                    // 发送签e签宝署验证短信
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/Tdpt.js